/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, localDateString } from '../runtime';
import type { FileId } from './FileId';
import { FileIdFromJSON, FileIdFromJSONTyped, FileIdToJSON } from './FileId';

/**
 *
 * @export
 * @interface EventCreateModel
 */
export interface EventCreateModel {
    /**
     *
     * @type {string}
     * @memberof EventCreateModel
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof EventCreateModel
     */
    description: string;
    /**
     *
     * @type {string}
     * @memberof EventCreateModel
     */
    link: string;
    /**
     *
     * @type {Date}
     * @memberof EventCreateModel
     */
    date: Date;
    /**
     *
     * @type {FileId}
     * @memberof EventCreateModel
     */
    fileId?: FileId;
}

/**
 * Check if a given object implements the EventCreateModel interface.
 */
export function instanceOfEventCreateModel(value: object): boolean {
    if (!('title' in value)) return false;
    if (!('description' in value)) return false;
    if (!('link' in value)) return false;
    if (!('date' in value)) return false;
    return true;
}

export function EventCreateModelFromJSON(json: any): EventCreateModel {
    return EventCreateModelFromJSONTyped(json, false);
}

export function EventCreateModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): EventCreateModel {
    if (json == null) {
        return json;
    }
    return {
        title: json['title'],
        description: json['description'],
        link: json['link'],
        date: new Date(json['date']),
        fileId: json['file_id'] == null ? undefined : FileIdFromJSON(json['file_id']),
    };
}

export function EventCreateModelToJSON(value?: EventCreateModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        title: value['title'],
        description: value['description'],
        link: value['link'],
        date: localDateString(value['date']),
        file_id: FileIdToJSON(value['fileId']),
    };
}
